var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 21.5417C27.8263 21.5417 31.3334 18.0346 31.3334 13.7083C31.3334 9.3821 27.8263 5.875 23.5001 5.875C19.1738 5.875 15.6667 9.3821 15.6667 13.7083C15.6667 18.0346 19.1738 21.5417 23.5001 21.5417Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83325 43.0835C7.83325 33.2918 15.6666 25.4585 23.4999 25.4585C31.3332 25.4585 39.1666 33.2918 39.1666 43.0835H7.83325Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/client.d0900afe36d308469e50dffd9a7e1c40.svg";